import React from 'react';
import PropTypes from 'prop-types';
import UserRolesList from '../UserRolesList';

import ImmutablePropTypes from 'react-immutable-proptypes';
import { TableauWrapper, InputElement, InputLabel } from 'src/components/EditUserForm/EditUserForm.style';

import { Map } from 'immutable';

import Form from '../Form';

class EditUserForm extends Form {
    static fieldsValidation = {
        name: [ 'required' ],
        email: [ 'required', 'email' ]
    };
    static propTypes = {
        roles: ImmutablePropTypes.map,
        user: ImmutablePropTypes.map,

        onActivateRequest: PropTypes.func,
        onSuspendRequest: PropTypes.func,
        onDeleteRequest: PropTypes.func,
        onRoleSelect: PropTypes.func,
        onCancelEditing: PropTypes.array
    };

    static defaultProps = {
        ...Form.defaultProps,
        roles: Map(),

        onActivateRequest: () => undefined,
        onSuspendRequest: () => undefined,
        onDeleteRequest: () => undefined,
        onRoleSelect: () => undefined,
    };

    constructor(props, context) {
        super(props, context);

        this.state = {
            ...this.state,
            data: props.user.toJS()
        };
    }

    UNSAFE_componentWillReceiveProps(props) {
        if (props.user !== this.props.user) {
            this.setState({
                data: props.user.toJS()
            });
        }
    }

    onSubmit(e, ...args) {
        e.preventDefault();
        super.onSubmit(e, ...args);
    }

    onRoleChange(roles) {
        const { data } = this.state;
        data.roles = roles.toJS();
        this.setState({ data });
    }

    cancelEditing() {
        this.props.onCancelEditing.map( action => action());
    }

    renderForm() {
        const { user } = this.props;

        const activateButton = (
            <button type='button'
                className='btn btn-primary'
                onClick={ this.props.onActivateRequest }
            >
                Activate
            </button>
        );

        const deleteButton = (
            <button onClick={ this.props.onDeleteRequest } type='button' className='btn'>
                Delete
            </button>
        );

        const suspendButton = (
            <button type='button'
                className='btn btn-primary'
                onClick={ this.props.onSuspendRequest }
            >
                Suspend
            </button>
        );
        
        return (
            <div>
                <div className='row'>
                    <div className='col-6'>
                        <h3>Details</h3>
                        { this.getField(
                            <input
                                disabled
                                type='text'
                                label='Name'
                                key='name'
                                { ...this.getFieldParameters('name') }
                            />
                        ) }
                        { this.getField(
                            <input
                                type='text'
                                disabled={this.props.isSuperUser === false}
                                label='Email'
                                key='email'
                                { ...this.getFieldParameters('email') }
                            />
                        ) }
                        { this.getField(
                            <input
                                type='text'
                                label='First name'
                                key='firstName'
                                { ...this.getFieldParameters('firstName') }
                            />
                        ) }
                        { this.getField(
                            <input
                                type='text'
                                label='Surname'
                                key='title'
                                { ...this.getFieldParameters('surname') }
                            />
                        ) }
                        { this.getField(
                            <input
                                type='text'
                                label='Job title'
                                key='jobTitle'
                                { ...this.getFieldParameters('jobTitle') }
                            />
                        ) }
                        { (this.props.tableauDashboards === true) ?

                            <div className='element empty hasLabel' data-test='tableau-login'>
                                <InputElement
                                    type='text'
                                    label='Tableau login'
                                    name='Tableau login'
                                    value={this.props.tableauInput}
                                    onChange={this.props.onTableauInputChange}
                                />
                                <label>Tableau login</label>
                            </div> :
                            null}
                    </div>
                    <div className='col-6'>
                        <h3>Roles</h3>
                        <UserRolesList
                            onRoleChange={ this.onRoleChange.bind(this)}
                            onRoleSelect={ this.props.onRoleSelect }
                            roles={ this.props.roles }
                            user={ this.props.user }
                            editing
                        />
                    </div>
                </div>
                <div className='row'>
                    <div className='col-12 user-edit-form__menu'>
                        <button onClick={ this.cancelEditing.bind(this) } type='button' className='btn'>
                            Reset Password
                        </button>
                        <button type='submit' className='btn btn-primary' data-test='save-button'>
                            Save
                        </button>
                        { user.get('status') === 'active' ? suspendButton : activateButton }
                        { user.get('status') !== 'closed' ? deleteButton : undefined }
                    </div>
                </div>
            </div>
        );
    }
}

export default EditUserForm;
